module.exports = __webpack_public_path__ + "ece8d6376a86861b1c9c5bca4c616c6a.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/venn_content_commerce.svg
// module id = 220
// module chunks = 0